const SubmitButton = ({ isLoading, children, success, disableTab, ...props }) => {
    return (
        <button
            type="submit"
            disabled={isLoading}
            tabIndex={disableTab ? -1 : 0}
            className={`submit-button ${success ? 'success' : ''}`}
            {...props}
        >
            {isLoading ? <span className="spinner" aria-hidden="true" /> : children}
        </button>
    );
};

export default SubmitButton;
